import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

export default function(props) {
    return (
        <Grid
            item
            sm={6}
            xs={12}
        >
            <Paper>
                <Typography
                    component="h3"
                    variant="h5"
                >
                    <p>{ props.children }</p>
                </Typography>
            </Paper>
        </Grid>
    );
}
